<div class="breadcrumb-container">
  <div class="home-item" (click)="backToList()" fiTranslation="REQUEST_DETAIL_LINK_ALL_ENQUIRIES"></div>
  <div class="icon">
    <mat-icon>chevron_right</mat-icon>
  </div>
  <div class="number">{{ number }}</div>
</div>
